import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgZapierLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.5857 16.5917C14.9236 17.2172 13.0609 17.2183 11.3987 16.5921C10.7724 14.9317 10.7723 13.0695 11.3977 11.4088C13.0595 10.7823 14.924 10.7822 16.5858 11.4087C17.2118 13.0689 17.2116 14.9316 16.5857 16.5917ZM26.0797 11.9584H18.9245L23.9837 6.90216C23.1897 5.78754 22.2095 4.80841 21.0942 4.01489L16.0346 9.07117V1.92062C14.6843 1.69361 13.2994 1.69395 11.9491 1.92062V9.07117L6.8895 4.01489C5.77447 4.80787 4.79393 5.78835 3.99988 6.90216L9.05982 11.9584H1.90473C1.72811 13.3484 1.67073 14.6546 1.90473 16.0417H9.05992L3.99997 21.098C4.79594 22.2143 5.77249 23.1902 6.8895 23.9856L11.9491 18.929V26.0799C13.2996 26.3061 14.684 26.3062 16.0345 26.0799V18.929L21.0945 23.9856C22.2103 23.1913 23.1888 22.213 23.9837 21.098L18.9237 16.0417H26.0797C26.3068 14.6934 26.3068 13.3067 26.0797 11.9584Z",
		fill: "#FF4A00"
	})
});
export default SvgZapierLogo;
